import { TemplateOperationKind } from './templateOperationKind.js';

export class TemplateOperation {
    templateName: string = '';
    kind: TemplateOperationKind = TemplateOperationKind.ComponentReplace;
    target: string = '';
    replacedWith: string = '';
    paramJson: string = '';
    operations: TemplateOperation[] = [];

    constructor(params: { templateName?: string; kind?: TemplateOperationKind; target?: string; replacedWith?: string; paramJson?: string; operations?: TemplateOperation[] } = {}) {
        this.templateName = params.templateName || '';
        this.kind = params.kind || TemplateOperationKind.ComponentReplace;
        this.target = params.target || '';
        this.replacedWith = params.replacedWith || '';
        this.paramJson = params.paramJson || '';
        this.operations = params.operations || [];
    }
}
